import styled from 'styled-components';

type RowStyleType = {
  hasMarginBottom?: boolean;
};

type DateDropdownFieldStyleType = {
  flatSide: 'left' | 'right';
};

export const Row = styled.div<RowStyleType>`
  display: flex;
  width: 100%;
  margin-bottom: ${(props) => (props.hasMarginBottom ? 16 : 0)}px;
`;

const FullWidth = styled.div`
  flex: 1;
`;

export const DateDropdownField = styled(FullWidth)<DateDropdownFieldStyleType>`
  button {
    border-top-${(props) => props.flatSide}-radius: 0px;
    border-bottom-${(props) => props.flatSide}-radius: 0px;
  }

  & + & {
    margin-left: 1px;
  }
`;

export const Column = styled(FullWidth)`
  & + & {
    margin-left: 40px;
  }
`;

export const Box = styled.div`
  border-bottom: 1px solid #ebebeb;
  margin-bottom: 30px;
  padding-bottom: 30px;
`;

export const TextAreaLabel = styled.p`
  margin-right: 12px;
  font-size: 14px;
  color: rgb(150, 151, 155);
`;

export const Footer = styled.div`
  display: flex;
  margin-top: 15px;
  gap: 16px;
`;
